import moment from 'moment';

import { VerificationObjectType, VerificationStatus, type MetricType } from 'webapp/enums/enums';

export interface VerificationInfoUser {
	id: number;
	name: string;
	avatar?: string | null;
}

export interface VerificationInfo {
	status: VerificationStatus;
	objectId: string;
	objectType: VerificationObjectType;
	created: string;
	createdBy: VerificationInfoUser | null;
	modified: string | null;
	modifiedBy: VerificationInfoUser | null;
}

export type VerificationBadgeSize = 'sm' | 'md';

export type VerificationEntityLabel =
	| 'dataset'
	| 'databoard'
	| 'report'
	| 'metric'
	| 'board loop'
	| 'custom query'
	| 'calculated metric';

export function getVerificationEntityDisplayName(label: VerificationEntityLabel): string {
	return label === 'databoard' ? 'dashboard' : label;
}

export function isVerified(info?: VerificationInfo): boolean {
	return info?.status === VerificationStatus.VERIFIED;
}

export function getVerifiedActor(
	info?: VerificationInfo,
): { name: string; avatar?: string | null } | null {
	return info?.modifiedBy ?? info?.createdBy ?? null;
}

export function getVerifiedDate(info?: VerificationInfo, format = 'MMM D, YYYY'): string {
	const timestamp = info?.modified ?? info?.created;
	if (!timestamp) {
		return '';
	}
	return moment(timestamp).format(format);
}

export function getMetricVerificationObjectType(objectType: MetricType): VerificationObjectType {
	if (objectType === ('custom_query' as MetricType)) return VerificationObjectType.CUSTOM_QUERY;
	if (objectType === ('metric_calculation' as MetricType))
		return VerificationObjectType.CALCULATED_METRIC;
	if (objectType === ('horizon' as MetricType)) return VerificationObjectType.CUSTOM_QUERY;
	return VerificationObjectType.BASIC_METRIC;
}

export function buildUnverifiedSkeleton(objectId: string, objectType: number): VerificationInfo {
	return {
		status: VerificationStatus.UNVERIFIED,
		objectId,
		objectType,
		created: '',
		createdBy: null,
		modified: null,
		modifiedBy: null,
	};
}

export function buildMetricCompositeId(key: string, spaceAccessId: number): string {
	return JSON.stringify({ key, spaceAccessId });
}
